module.exports = __webpack_public_path__ + "img/レクサス.37a206e8.png";